// Services
import axios from 'services/axios'

// Endpoint
import {
  API_ANNOUNCEMENT_DOWNLOAD_FILE,
  API_ANNOUNCEMENT_INFO,
  API_ANNOUNCEMENT_LIST,
} from 'constants/endpoints'

// Models
import Announcement from 'models/Announcement'

/**
 * Get announcement info
 *
 * @param {Number} id
 * @returns {Object}
 */
export const getAnnouncementInfo = async ({
  announcementId,
  notificationId,
}) => {
  try {
    const { data } = await axios.get(API_ANNOUNCEMENT_INFO, {
      params: {
        announcementId,
        notifiId: notificationId,
      },
    })
    return new Announcement(data)
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Download attach file
 *
 * @param {String} fileName
 * @return {Object}
 */
export const downloadAttachFile = async (name) => {
  try {
    await axios.get(API_ANNOUNCEMENT_DOWNLOAD_FILE, {
      params: {
        fileName: name,
      },
      downloadFile: true,
    })
  } catch (error) {
    return Promise.reject(error)
  }
}

/**
 * Get announcement list
 *
 * @returns {Object}
 */
export const getAnnouncementList = async () => {
  try {
    const { data } = await axios.get(API_ANNOUNCEMENT_LIST)
    return data
      ? data.map((announcement) => {
          return new Announcement(announcement)
        })
      : []
  } catch (error) {
    return Promise.reject(error)
  }
}
